import React from "react";
import { Navigate } from "react-router-dom";

/**
 * Individual blog article page — temporarily disabled.
 *
 * HL Partnership's Financial Promotions team requires every blog to be
 * pre-approved before publishing. Until each article has been signed off,
 * any /insights/:slug URL redirects to the compliance placeholder on the
 * Insights index page. The article content still lives in
 * `/app/frontend/src/data/insights.js` for easy re-enable once approvals
 * come back.
 */
export default function InsightDetail() {
    return <Navigate to="/insights" replace />;
}
